import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors - but don't redirect on initial auth check
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect if we're not on the login/register page and not doing initial auth check
      const isAuthPage = window.location.pathname === '/login' || window.location.pathname === '/register';
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      
      if (!isAuthPage && !isAuthCheck) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Categories API
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
  getOne: (key) => api.get(`/categories/${key}`),
};

// Professionals API
export const professionalsAPI = {
  search: (params) => api.get('/professionals', { params }),
  getOne: (id) => api.get(`/professionals/${id}`),
  createProfile: (data) => api.post('/professionals/profile', data),
  getMyProfile: () => api.get('/professionals/my-profile'),
  updateMyProfile: (data) => api.patch('/professionals/my-profile', data),
};

// Bookings API
export const bookingsAPI = {
  create: (data) => api.post('/bookings', data),
  getAll: () => api.get('/bookings'),
  updateStatus: (id, status) => api.patch(`/bookings/${id}/status`, { status }),
};

// Reviews API
export const reviewsAPI = {
  create: (data) => api.post('/reviews', data),
  getByProfessional: (id) => api.get(`/reviews/professional/${id}`),
};

// Subscription API
export const subscriptionAPI = {
  getPlans: () => api.get('/subscription/plans'),
  getStatus: () => api.get('/subscription/status'),
  createCheckout: (data) => api.post('/subscription/checkout', data),
  getCheckoutStatus: (sessionId) => api.get(`/subscription/checkout/status/${sessionId}`),
  updateAutoRenew: (autoRenew) => api.patch('/subscription/auto-renew', { auto_renew: autoRenew }),
  getPaymentHistory: () => api.get('/subscription/payments'),
  getReferralInfo: () => api.get('/subscription/referrals'),
};

export default api;
